// Bukhara region districts — hardcoded reference list (ТЗ п.3.1, Вопрос 3А).
// Slugs are used as stable ids in storage/history; name_uz is the display /
// Excel-matching name. 13 entries = 2 shahar + 11 tuman.

export const districts = [
	{ id: 'buxoro-city',   name_uz: "Buxoro shahri",       type: 'shahar' },
	{ id: 'kogon-city',    name_uz: "Kogon shahri",        type: 'shahar' },
	{ id: 'buxoro-tuman',  name_uz: "Buxoro tumani",       type: 'tuman' },
	{ id: 'vobkent',       name_uz: "Vobkent tumani",      type: 'tuman' },
	{ id: 'gijduvon',      name_uz: "G'ijduvon tumani",    type: 'tuman' },
	{ id: 'jondor',        name_uz: "Jondor tumani",       type: 'tuman' },
	{ id: 'kogon-tuman',   name_uz: "Kogon tumani",        type: 'tuman' },
	{ id: 'olot',          name_uz: "Olot tumani",         type: 'tuman' },
	{ id: 'peshku',        name_uz: "Peshku tumani",       type: 'tuman' },
	{ id: 'qorakol',       name_uz: "Qorako'l tumani",     type: 'tuman' },
	{ id: 'qorovulbozor',  name_uz: "Qorovulbozor tumani", type: 'tuman' },
	{ id: 'romitan',       name_uz: "Romitan tumani",      type: 'tuman' },
	{ id: 'shofirkon',     name_uz: "Shofirkon tumani",    type: 'tuman' },
]

export const districtById = districts.reduce((acc, d) => {
	acc[d.id] = d
	return acc
}, {})

export const getDistrictName = (id) => districtById[id]?.name_uz || id

/**
 * Normalize an Uzbek district name for tolerant matching (Вопрос 3б).
 * Handles the four apostrophe variants ('  ʻ  '  `), the plain "o"/"g"
 * (no diacritic) case, whitespace and case. Apostrophes are dropped entirely
 * so "G'ijduvon" / "Gʻijduvon" / "G‘ijduvon" / "Gijduvon" all collapse equal.
 */
export const normalizeDistrictName = (value = '') =>
	String(value)
		.toLowerCase()
		.replace(/[’‘ʻ`'ʼ]/g, '')   // drop all apostrophe-like marks
		.replace(/\s+/g, ' ')
		.trim()

// Strip the trailing type word so "G'ijduvon" matches "G'ijduvon tumani".
const stripType = (name) =>
	name.replace(/\s+(tumani|shahri|shahar|tuman)$/i, '').trim()

// Precomputed normalized keys per district (full name + name without suffix).
const districtKeys = districts.map(d => {
	const full = normalizeDistrictName(d.name_uz)
	return { district: d, keys: new Set([full, stripType(full)]) }
})

/**
 * Resolve a raw "Tuman" cell value to a district, or null if unknown.
 * Strict header validation stays elsewhere; this is the value-level match.
 */
export const findDistrictByName = (value) => {
	const norm = normalizeDistrictName(value)
	if (!norm) return null
	const normNoType = stripType(norm)
	const hit = districtKeys.find(
		({ keys }) => keys.has(norm) || keys.has(normNoType)
	)
	return hit ? hit.district : null
}

export default districts
